export const LimitInputLength = angular
    .module('checkout.directives.limitInputLength', [])
    .directive('limitInputLength', () => {
        return {
            restrict: 'A',
            link: (scope, elem, attrs) => {
                const limit = parseInt(attrs.limitInputLength);
                angular.element(elem).on('keypress', function(event) {
                    if (this.value.length === limit && event.key !== 'Backspace') event.preventDefault();
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/limitInputLength.directive.js